export const UPDATE_CUSTOMER_REQUEST = 'customers/UPDATE_CUSTOMER_REQUEST'
export const UPDATE_CUSTOMER_SUCCESS = 'customers/UPDATE_CUSTOMER_SUCCESS'
export const UPDATE_CUSTOMER_FAIL = 'customers/UPDATE_CUSTOMER_FAIL'
